module.exports = __webpack_public_path__ + "img/dfrancisco.51ad1219.png";